"use client";

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useCart } from "@/contexts/cart-context";
import { useCartSheet } from "@/contexts/cart-sheet-context";
import { TextScramble } from "@/components/ui/text-scramble";
import { usePathname } from "next/navigation";
import { Cart } from "./Cart";

export function CartSheet() {
  const { isOpen, setIsOpen } = useCartSheet();
  const { getTotalItems } = useCart();
  const totalItems = getTotalItems();
  const pathname = usePathname();

  // Check if the current pathname starts with "/cart"
  const isActive = pathname.startsWith("/cart");

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <button
          className={`flex items-center space-x-1 text-xs uppercase group ${
            isActive ? "text-[#FF0000]" : ""
          }`}
        >
          <TextScramble characterSet=". " className="group-hover:underline">
            Cart
          </TextScramble>
          <span className="text-[#FF0000] group-hover:underline">
            {totalItems > 0 ? `[${totalItems}]` : null}
          </span>
        </button>
      </SheetTrigger>
      <SheetContent className="w-full sm:max-w-lg">
        <SheetHeader>
          <SheetTitle>
            <TextScramble
              characterSet=". "
              className="text-xs font-mono uppercase text-muted-foreground"
            >
              Your Cart
            </TextScramble>
          </SheetTitle>
        </SheetHeader>
        <div className="h-4" />
        <Cart onClose={handleClose} isSheet={true} />
      </SheetContent>
    </Sheet>
  );
}
